<div class="row">
  <div class="col-lg-12 card shadow-sm" style="padding-left: 0 !important; padding-right: 0 !important;"> 
    <app-field-viewer 
                      class="p-2"
                      *ngIf="settings.CampiAggiuntivi && showFilters"
                      [Campi]="settings['CampiAggiuntivi']"
                      [(Oggetto)]="filters"
                      (OnChange)="onFiltroChange($event)"
                      >
    </app-field-viewer>
  </div>
  </div>
  
  <div class="actions mb-3 d-flex gap-2">
    <button *ngIf="settings.enableCheckAll"
            class="btn btn-outline-success"
            (click)="selectAll()">
      {{ settings.selectAllText }}
    </button>
    <button *ngIf="settings.enableCheckAll"
            class="btn btn-outline-danger"
            (click)="unSelectAll()">
      {{ settings.unSelectAllText }}
    </button>
  </div>
  <div *ngIf="toggleList() ">
    <div class="row g-3">
      <div *ngFor="let item of items"
      style="margin-top: 10px !important;"
       [ngClass]="{
        'col-md-6 col-lg-6': items.length > 1,
        'col-md-12 col-lg-12': items.length == 1
        }">
        <div class="card h-100 shadow-sm p-2"
             
             [class.selected]="item.isSelected"
             (click)="toggleItem(item)">
          
          <!-- CHECKBOX IN ALTO A SINISTRA -->
          
          <!-- CONTENUTO PRINCIPALE -->
          <div class="d-flex align-items-center pt-2">
            <div class="ml-2 pr-2">
              <input type="checkbox"
              class="big-checkbox"
                     [(ngModel)]="item.isSelected"
                     (click)="$event.stopPropagation(); toggleItem(item)">
            </div>
            <!-- IMMAGINE -->
            <img [src]="getImageLink(item[settings.images[0].idImage])"
                 [style.width.px]="settings.images[0].width"
                 [style.height.px]="settings.images[0].height"
                 class="rounded me-3">
  
            <!-- TESTO -->
            <div class="d-flex flex-column">
              <h5 class="card-title mb-1">{{ item[settings.textField] }}</h5>
              <p class="card-text mb-1">{{ item[settings.descriptionField] }}</p>
              <small class="text-muted">Codice: {{ item[settings.codeField] }}</small>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  
    <!-- PAGINAZIONE -->
    <div *ngIf="showFilters && (totalItems / pageSize) > 1" class="d-flex justify-content-center mt-4">
      <ngb-pagination [collectionSize]="totalItems"
                      [(page)]="page"
                      [maxSize]="10"
                      [pageSize]="pageSize"
                      (pageChange)="onPageChange($event)">
      </ngb-pagination>
    </div>
  </div>
  
  
  